import { render, staticRenderFns } from "./AmbassadorsList.vue?vue&type=template&id=c2f346d2&"
import script from "./AmbassadorsList.vue?vue&type=script&lang=js&"
export * from "./AmbassadorsList.vue?vue&type=script&lang=js&"
import style0 from "./AmbassadorsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports